import { Switch } from "@headlessui/react";
import { ReactNode, useEffect, useState } from "react";

interface IToggle {
  checked: boolean;
  handleChange: () => void;
  disabled?: boolean;
  highlight?: boolean;
  highlightSize?: "default" | "wide";
}

export interface IdisplaySettingsOptions {
  setting: string;
  heading: string;
  blurb: string;
  component: ReactNode;
}

function Toggles({
  checked,
  handleChange,
  disabled = false,
  highlight = false,
  highlightSize = "default",
}: IToggle) {
  const [currentStoreValue, setcurrentStoreValue] = useState(checked);

  useEffect(() => {
    setcurrentStoreValue(checked);
  }, [checked]);

  function changeStore() {
    if (disabled) return;
    handleChange();
    setcurrentStoreValue(!currentStoreValue);
  }

  return (
    <>
      {highlight && (
        <style>{`
          @keyframes toggle-highlight-pulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.4); }
            50% { box-shadow: 0 0 6px 3px rgba(251, 146, 60, 0.7); }
          }
          @keyframes toggle-highlight-pulse-wide {
            0%, 100% { box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.4); }
            50% { box-shadow: 0 0 12px 8px rgba(251, 146, 60, 0.7); }
          }
        `}</style>
      )}
      <Switch
        id="themeSwitch"
        data-testid="toggleButton"
        onClick={changeStore}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
          disabled
            ? "cursor-not-allowed opacity-50"
            : "cursor-pointer"
        } ${
          currentStoreValue
            ? "bg-gray-300 dark:bg-gray-500"
            : "bg-gray-300 dark:bg-gray-500"
        }`}
        style={
          highlight
            ? {
                animation: `${
                  highlightSize === "wide"
                    ? "toggle-highlight-pulse-wide"
                    : "toggle-highlight-pulse"
                } 0.8s ease-in-out infinite`,
              }
            : undefined
        }
      >
      <span
        className={`pointer-events-none relative inline-block h-5 w-5 transform rounded-full  shadow ring-0 transition duration-200 ease-in-out ${
          currentStoreValue
            ? "translate-x-5 bg-orange-400 dark:bg-orange-500"
            : "translate-x-0 bg-gray-100 dark:bg-gray-300"
        }`}
      >
        <span
          className={`absolute inset-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out ${
            currentStoreValue ? " opacity-0" : "opacity-100"
          }`}
          aria-hidden="true"
        ></span>
        <span
          className={`absolute inset-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out ${
            currentStoreValue ? "opacity-100" : "opacity-0"
          }`}
          aria-hidden="true"
        ></span>
      </span>
      </Switch>
    </>
  );
}

export default Toggles;
